import { Button, Select } from '@pms-digital/design-system';
import {
  NOTES_SORTS,
  NOTES_SORT_LABELS,
  type NotesSort,
  type NotesSortDirection,
} from './notes-view-search';

export interface NotesSortControlsProps {
  sort: NotesSort;
  dir: NotesSortDirection;
  onSortChange: (sort: NotesSort) => void;
  onToggleDirection: () => void;
}

const SORT_OPTIONS = NOTES_SORTS.map((value) => ({ value, label: NOTES_SORT_LABELS[value] }));

function isSort(value: string): value is NotesSort {
  return value in NOTES_SORT_LABELS;
}

/**
 * « Trier par » (one criterion) and the button that inverts the order next to
 * it; its name says the current direction.
 */
export function NotesSortControls({
  sort,
  dir,
  onSortChange,
  onToggleDirection,
}: NotesSortControlsProps) {
  const directionLabel =
    dir === 'desc'
      ? 'Ordre décroissant - cliquer pour inverser'
      : 'Ordre croissant - cliquer pour inverser';

  return (
    <div className="flex items-end gap-2">
      <Select
        label="Trier par"
        options={SORT_OPTIONS}
        value={sort}
        onValueChange={(value) => {
          if (isSort(value)) onSortChange(value);
        }}
      />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        icon={dir === 'desc' ? 'arrow_downward' : 'arrow_upward'}
        aria-label={directionLabel}
        title={directionLabel}
        onClick={onToggleDirection}
      />
    </div>
  );
}
